module.exports = __webpack_public_path__ + "static/media/Surrounding7.d47cd62d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Surrounding7.jpeg
// module id = 580
// module chunks = 0